<template>
	<strong :class="statusClass">{{ status === 0 ? "OK" : status.toLocaleString() }}</strong>
</template>

<script>
	export default {
		name: "StatusValue",
		props: ["status", "since" ],
		computed: {
			statusClass() {
				let val = this.status;
				let since = this.since;
				if (val && isNaN(val)) val = val.toLowerCase();
				if (val === "down") return "critical";
				if (parseInt(val) >= 10 && parseInt(since) < 5) return "critical";
				if (parseInt(val) >= 5) return "warning";
				if (parseInt(val) > 0) return "notice";
				return "ok"
			}
		}
	};
</script>


// WEBPACK FOOTER //
// status-value.vue?69aabf80